import React, { useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import apiService from '../../../../utils/apiService';
import { DataLayerEventContext } from '../../../../contexts/dataLayerEventContext';

const PhoneScreen = ({ setScreenNumber, handleNextScreen }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    sendEvent('phone_seen_authorization');
  }, []);

  const handleCheckPhone = () => {
    const regex = /^380\d{9}$/;
    const updatedPhone = phone.replace(/\D/g, '').replace(/^380/, '380');

    if (!regex.test('380' + updatedPhone)) setPhoneError(true);

    return regex.test('380' + updatedPhone);
  };

  const handleNext = async () => {
    if (isSubmitting) return;
    const isValid = handleCheckPhone();

    if (!isValid) return;

    try {
      setIsSubmitting(true);
      const formattedPhone = '380' + phone.replace(/\D/g, '');
      sessionStorage.setItem('p_n', formattedPhone);

      await apiService.post('test/registration/otp', {
        data: {
          phone: formattedPhone
        }
      });

      handleNextScreen();
    } catch (error) {
      console.error('Error sending OTP:', error);
      console.log('Error response:', error.response?.data);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: 'url("/images/26ua-lm-lfc-auth/bg.png")' }}
    >
      <div className={styles.content}>
        <p className={styles.title}>Найцікавіше близько!</p>
        <p className={styles.description}>
          Введи номер телефону для авторизації.
          <br></br>P.S. Обіцяємо нудно не буде 😁
        </p>
        <div className={styles.phoneInputContainer}>
          <div className={styles.labelContainer}>
            <p>Код</p>
            <p>Номер телефону*</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.codeContainer}>+380</div>
            <InputMask
              mask="(99) 999-99-99"
              maskChar="_"
              alwaysShowMask
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onFocus={() => setPhoneError(false)}
              onBlur={handleCheckPhone}
              className={classNames(
                styles.input,
                phoneError && styles.errorInput
              )}
            >
              {(inputProps) => <input {...inputProps} type="tel" />}
            </InputMask>
          </div>
          {phoneError && (
            <p className={styles.error}>Перевір коректність номеру</p>
          )}
        </div>
        <button
          className={styles.nextButton}
          onClick={handleNext}
          disabled={isSubmitting}
        >
          <img
            className={styles.buttonGlow}
            src="/images/26ua-lm-lfc-auth/button-glow.svg"
            alt=""
          />
          {isSubmitting && <span className={styles.spinner} />}
          <span>Далі</span>
        </button>
      </div>
      <div className={styles.footer}>
        Натискаючи «ДалI» ти робиш запит на отримання інформації про продукцію
        компанії Філіп Морріс засобами дистанційного зв'язку відповідно до
        частини 2 статті 15 Закону «Про захист прав споживачів» та підтверджуєш,
        що Є СПОЖИВАЧЕМ ТЮТЮНОВИХ ВИРОБІВ ТА/АБО КОРИСТУВАЧЕМ ПРИСТРОЇВ ДЛЯ
        СПОЖИВАННЯ ТЮТЮНОВИХ ВИРОБІВ БЕЗ ЇХ ЗГОРЯННЯ“.
      </div>
      <div className={styles.linksContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(2)}>Умови використання</button>
        <button onClick={() => setScreenNumber(3)}>FAQ</button>
        <button onClick={() => setScreenNumber(4)}>
          Параметри застосування файлів cookies
        </button>
      </div>
    </div>
  );
};

export default PhoneScreen;
